export const description =
  "Coup de pouce CEE 2026 : guide complet du dispositif de bonification des primes énergie. Coup de pouce Chauffage, Isolation et Rénovation performante, barèmes selon revenus (Bleu/Jaune/Violet/Rose), conditions, démarches, cumul avec MaPrimeRénov’. Encadré par charte qualité officielle.";
